import type { ErrorName } from "../types/errors/ErrorName"

export const EngineError = (code: ErrorName) => new Error(code)
